import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: JSON.parse(localStorage.getItem('cart')) || [],
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addToCart: (state, action) => {
                        
            const existingItem = state.items.find(item => item.ID === action.payload.ID);                                    
            if (existingItem) {
                if (existingItem.cartItemId==action.payload.cartItemId) {
                    existingItem.Quantity += action.payload.Quantity;
                }
                else
                {
                    state.items.push({ ...action.payload });
                }
            
            } else {
                state.items.push({ ...action.payload });
            }
            localStorage.setItem('cart', JSON.stringify(state.items));
        },
        removeFromCart: (state, action) => {
            state.items = state.items.filter(item => item.cartItemId !== action.payload.cartItemId);

            
            localStorage.setItem('cart', JSON.stringify(state.items));
        },
        updateQuantity: (state, action) => {
            const cartItemId = action.payload.cartItemId;
            
            
            const item = state.items.find((item) => item.cartItemId === cartItemId);            
            
            if (item) {
                item.Quantity =  action.payload.Quantity
            }
            localStorage.setItem('cart', JSON.stringify(state.items));
        },
        clearCart: (state) => {
            state.items = [];
            localStorage.setItem('cart', JSON.stringify(state.items));
        }
    },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
